/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DataActionConditionType } from 'cio/utils/campaigns/data-action';
import { shouldShowRemoveAttribute } from 'cio/utils/actions/create-or-update-person';

interface CreateOrUpdatePersonEditSidebarAttributeRowArgs {
  row: {
    name: string;
    type: DataActionConditionType;
    value: string;
  };
}

export default class CreateOrUpdatePersonEditSidebarAttributeRowComponent extends Component<CreateOrUpdatePersonEditSidebarAttributeRowArgs> {
  get showRemoveAttribute() {
    return shouldShowRemoveAttribute(this.args.row);
  }
}
